var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"loading"},[_c('font-awesome-icon',{attrs:{"icon":['fas','circle-notch']}})],1),_c('div',{class:_vm.labelClass},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }